import * as React from "react";
import { useParams } from "react-router-dom";

// Passes the url params to class components as props.match.params, like react-router v5 did.
export function withRouter<P extends { match: { params: object } }>(Component: React.ComponentType<P>) {
    return function WithRouter(props: Omit<P, "match">) {
        const params = useParams();
        return <Component {...(props as P)} match={{ params }} />;
    };
}
